import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminDataFeeds from "@/pages/admin/AdminDataFeeds";

export const Route = createFileRoute("/admin/data-feeds/")({
  component: () => (
    <ProtectedRoute>
      <AdminDataFeeds />
    </ProtectedRoute>
  ),
});
